// #tag: RESULTS API CLIENT
// #purpose: Dispatches API queries for paginated scorecards, latest releases, and detailed exam result records.
import { apiGet } from './client';
import type { ExamResult } from '../types';

export interface PaginatedResponse<T> {
  data: T[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export interface ResultsQuery {
  q?: string;
  category?: string;
  examCategory?: string;
  isNew?: boolean;
  page?: number;
  limit?: number;
}

function toQuery(params: Record<string, string | number | boolean | undefined>): string {
  const sp = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== '' && value !== 'all') sp.set(key, String(value));
  });
  const qs = sp.toString();
  return qs ? `?${qs}` : '';
}

export function fetchResults(query: ResultsQuery = {}): Promise<PaginatedResponse<ExamResult>> {
  return apiGet(`/results${toQuery(query as Record<string, string | number | boolean | undefined>)}`);
}

export function fetchLatestResults(limit = 3): Promise<{ data: ExamResult[] }> {
  return apiGet(`/results/latest?limit=${limit}`);
}

export function fetchResultById(id: string): Promise<ExamResult> {
  return apiGet(`/results/${id}`);
}
